<template>
  <div>
    <b-alert v-if="error_message"  :show="true" variant="danger" class="bg-white">
      <div class="iq-alert-text">{{ error_message }}</div>
    </b-alert>
    <b-alert v-if="success_message" :show="true" variant="success" class="bg-white">
      <div class="iq-alert-text">{{ success_message }}</div>
    </b-alert>
  </div>
  </template>
  <script>
  export default {
    name: "ErrorMessage",
    props: {
      error_message: {
        type: String,
        default: ""
      },
      success_message: {
      type: String,
      default: ""
    },
    }
  };
  </script>
  